/**
 * Created by Viktor on 2016.04.11..
 */
$(function(){
    if($('.block-login').length>0) {
        loginForm.init();
        regForm.init();
        lostPwForm.init();
    }
});

loginForm = {
    form: null,
    box: null,

    init: function(){
        this.form= $('#loginForm');
        this.box = $('.block-login');

        $(this.form).submit(this.submitForm);

        $('#lost_pw').click(function(){
            loginForm.hideForm();
        })
    },

    submitForm: function(e){
        e.preventDefault();
        $(this).find('.alert').fadeOut(function(){
            this.remove();
        });
        var data = {
            email: $(this).find('input[name=email]').val(),
            password: $(this).find('input[name=password]').val(),
        };

        if($(this).data('redirect')){
            data.redirect = $(this).data('redirect');
        }

        $.ajax({
            url: 'ajaxRequest/userRequest/login',
            method: 'POST',
            dataType: 'json',
            data: data,
            success: function(msg){
                if (msg.result === 'error') {
                    loginForm.loginError(msg);
                }
                if (msg.result === 'success') {
                    loginForm.loginSuccess(msg);
                }
            }
        })
    },

    loginSuccess:function(msg){
        if(msg.type == 'redirect'){
            window.location = msg.data;
        }
        else if(msg.type == 'sysmsg'){
            var div = '<div class="alert alert-success"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>';
            div += msg.data.title;
            div += '</div>';
            $(this.form).prepend(div);
        }
    },

    loginError: function(error){
        var div = '<div class="alert alert-danger"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>';
        div += error.data.error;
        div +='</div>';
        $(this.form).prepend(div);
    },

    hideForm: function(){
        $('.block-reg').fadeOut();
        $(this.box).fadeOut(function(){
            loginForm.resetForm();
            regForm.resetForm();
            lostPwForm.showForm();
        })
    },

    showForm: function(){
        $(this.box).fadeIn();
        $('.block-reg').fadeIn();
    },

    resetForm: function(){
        $(this.form)[0].reset();
    }
};

regForm = {
    form: null,

    init: function () {
        this.form = $('#registrationForm');

        $(this.form).submit(this.submitForm);
    },

    submitForm: function (e) {
        e.preventDefault();

        $(this).find('.alert').remove();

        if(!$(this).find('input[name=accept_policy]:checked').length){
            var chbox = $(this).find('input[name=accept_policy]');
            var div = '<div class="alert alert-danger" id="cc1"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>';
            div += $(chbox).data('error');
            div +='</div>';
            $(div).insertBefore(chbox);
            return false;
        }

        if(!$(this).find('input[name=accept_privacy]:checked').length){
            var chbox = $(this).find('input[name=accept_privacy]');
            var div = '<div class="alert alert-danger" id="cc1"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>';
            div += $(chbox).data('error');
            div +='</div>';
            $(div).insertBefore(chbox);
            return false;
        }

        var data = {
            name: $(this).find('input[name=name]').val(),
            email: $(this).find('input[name=email]').val(),
            password: $(this).find('input[name=password]').val(),
            accept_policy:$(this).find('input[name=accept_policy]').val(),
            accept_privacy:$(this).find('input[name=accept_privacy]').val(),
            subscribe_newsletter:$(this).find('input[name=subscribe_newsletter]:checked').val(),
        };

        if($(this).data('redirect')){
            data.redirect = $(this).data('redirect');
        }

        $.ajax({
            url: 'ajaxRequest/userRequest/registration',
            method: 'POST',
            dataType: 'json',
            data: data,
            success: function (msg) {
                if (msg.result === 'error') {
                    regForm.regError(msg);
                }
                if (msg.result === 'success') {
                    regForm.regSuccess(msg);
                }
            }
        })
    },
    regSuccess: function (msg) {
        if(msg.type == 'redirect'){
            window.location = msg.data;
        }
    },

    regError: function (error) {
        for (var prop in error.data) {
            if (error.data.hasOwnProperty(prop)) {
                var div = '<div class="alert alert-danger"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>';
                div += error.data[prop];
                div += '</div>';
                $(this.form).prepend(div);
            }
        }
    },

    resetForm: function(){
        $(this.form)[0].reset();
    }
};

lostPwForm = {
    form: null,
    box: null,

    init: function () {
        this.form = $('#lostPwForm');
        this.box = $('#lost_pw_box');

        $(this.form).submit(this.submitForm);
    },

    submitForm: function (e) {
        e.preventDefault();

        $(this).find('.alert').remove();


        var data = {
            lostpass_email: $(this).find('input[name=lostpass_email]').val(),
        };

        $.ajax({
            url: 'ajaxRequest/userRequest/lostpass',
            method: 'POST',
            dataType: 'json',
            data: data,
            success: function (msg) {
                if (msg.result === 'error') {
                    lostPwForm.lostpwError(msg);
                }
                if (msg.result === 'success') {
                    lostPwForm.lostpwSuccess(msg);
                }
            }
        })
    },
    lostpwSuccess: function (msg) {
        this.resetForm();
        if(msg.type == 'redirect'){
            window.location = msg.data;
        }
        else if(msg.type == 'sysmsg'){
            this.hideForm(msg);
        }
    },

    lostpwError: function (error) {

        for (var prop in error.data) {
            if (error.data.hasOwnProperty(prop)) {
                var div = '<div class="alert alert-danger"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>';
                div += error.data[prop];
                div += '</div>';
                $(this.form).prepend(div);
            }
        }
    },

    hideForm: function(msg){
        loginForm.loginSuccess(msg);
        $(this.box).fadeOut(function(){
            loginForm.showForm();
        });
    },

    showForm: function(){
        $(this.box).fadeIn();
    },

    resetForm: function(){
        $(this.form)[0].reset();
    }
}